export const GRASS_CAMPAIGN_JOIN_DATA = [
  {
    title: '결국, 무엇이든 해내는\n개발자로 성장하도록',
    description: [
      '개발자가 어떤 시대에도 살아 남을 수 있도록,\n항해99는 실무 역량 강화 프로그램부터\n커리어 코칭까지, 현직 개발자가 성장을\n이어나갈 수 있는 다양한 교육과 활동을 펼치고 있어요.',
      '재능과 환경에 구애받지 않고 끊임없이 성장해\n나가실 수 있도록, 항해99가 나침반이 되어드리겠습니다.',
      '인생을 바꾸는 항해에 함께하세요.',
    ],
  },
];
